"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.setupSagaTarget = setupSagaTarget;
exports.getSagaTarget = getSagaTarget;


/**
 * Setup saga target
 * @param {Function} saga Saga function
 * @param {boolean} server run on server
 * @param {boolean} browser run on browser
 * @returns {Function} saga function
 */
function setupSagaTarget(saga) {
    var server = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var browser = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    var target = { server: server, browser: browser };
    var sagaProto = saga.prototype;
    sagaProto.target = target;
    return saga;
}

/**
 * Get saga target from saga generator
 * @param {Function} saga saga generator function
 * @returns {*|{server: boolean, browser: boolean}} target object
 */


/**
 * The saga target type
 */
function getSagaTarget(saga) {
    return saga.prototype.target || { server: true, browser: true };
}
//# sourceMappingURL=sagaTarget.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/saga-utils/dist/main/sagaTarget.js
// module id = 532
// module chunks = 0